"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.trim");

var _classCallCheck = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/docs/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _Button = _interopRequireDefault(require("@arcblock/ux/lib/Button"));

var _Util = require("@arcblock/ux/lib/Util");

var _session = require("../Contexts/session");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * DID:Connect component that can be used to allow user to login and display user profile
 * TODO: this component remains a class component now because hook component will crash gatsby build
 */


var LoginButton = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(LoginButton, _react$default$Compon);

  var _super = _createSuper(LoginButton);

  function LoginButton(props) {
    var _this;

    _classCallCheck(this, LoginButton);

    var newProps = (0, _Util.mergeProps)(props, LoginButton, []);
    _this = _super.call(this, newProps);
    _this.state = {
      anchorEl: null,
      open: false
    };
    return _this;
  }

  _createClass(LoginButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.session.user && !this.props.session.user) {
        setTimeout(function () {
          _this2.setState({
            anchorEl: null,
            open: false
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          signInText = _this$props.signInText,
          signOutText = _this$props.signOutText,
          btnSize = _this$props.btnSize,
          btnColor = _this$props.btnColor,
          btnVariant = _this$props.btnVariant,
          userLabel = _this$props.userLabel,
          className = _this$props.className,
          session = _this$props.session,
          rest = _objectWithoutProperties(_this$props, ["signInText", "signOutText", "btnSize", "btnColor", "btnVariant", "userLabel", "className", "session"]);

      var _ref = session || {},
          error = _ref.error,
          user = _ref.user,
          loading = _ref.loading,
          login = _ref.login,
          logout = _ref.logout;

      var _this$state = this.state,
          anchorEl = _this$state.anchorEl,
          open = _this$state.open;

      if (!user) {
        var button = _react["default"].createElement(_Button["default"], {
          disableRipple: true,
          onClick: login,
          variant: btnVariant,
          color: btnColor,
          className: "login-button ".concat(className).trim(),
          disabled: loading,
          size: btnSize
        }, signInText);

        if (error) {
          return _react["default"].createElement(Container, rest, _react["default"].createElement(_Tooltip["default"], {
            title: "Error: ".concat(error)
          }, button));
        }

        return _react["default"].createElement(Container, rest, button);
      }

      return _react["default"].createElement(_ClickAwayListener["default"], {
        onClickAway: function onClickAway() {
          return _this3.setState({
            open: false,
            anchorEl: null
          });
        }
      }, _react["default"].createElement(Container, rest, _react["default"].createElement(_IconButton["default"], {
        "class": "avatar-button",
        onClick: function onClick(e) {
          return _this3.setState({
            anchorEl: e.currentTarget,
            open: !open
          });
        },
        disableRipple: true
      }, _react["default"].createElement(_Avatar["default"], {
        className: "user-avatar",
        variant: "circle",
        src: user.avatar,
        alt: user.name
      })), anchorEl && open && _react["default"].createElement(_Popper["default"], {
        open: true,
        disablePortal: true,
        anchorEl: anchorEl,
        placement: "bottom-end"
      }, _react["default"].createElement(UserProfile, null, _react["default"].createElement(_Avatar["default"], {
        className: "user-avatar",
        variant: "circle",
        src: user.avatar,
        alt: user.name
      }), _react["default"].createElement(_Typography["default"], {
        className: "user-label"
      }, userLabel), _react["default"].createElement(_Typography["default"], {
        className: "user-name"
      }, user.name), _react["default"].createElement(_Button["default"], {
        className: "user-logout",
        variant: "outlined",
        size: "small",
        onClick: logout
      }, signOutText)))));
    }
  }]);

  return LoginButton;
}(_react["default"].Component);

LoginButton.propTypes = {
  session: _propTypes["default"].object,
  className: _propTypes["default"].string,
  signInText: _propTypes["default"].string,
  signOutText: _propTypes["default"].string,
  userLabel: _propTypes["default"].string,
  btnSize: _propTypes["default"].string,
  btnColor: _propTypes["default"].string,
  btnVariant: _propTypes["default"].string
};
LoginButton.defaultProps = {
  session: {},
  className: '',
  signInText: 'Sign In',
  signOutText: 'Sign Out',
  userLabel: 'ArcBlock User',
  btnSize: 'medium',
  btnColor: 'default',
  btnVariant: 'outlined'
};
LoginButton.contextTypes = {
  session: _propTypes["default"].object
};

var Container = _styledComponents["default"].div.withConfig({
  displayName: "LoginButton__Container",
  componentId: "njq1cu-0"
})([".avatar-button{border:none;background-color:transparent;outline:none !important;cursor:pointer;width:48px;height:48px;}.user-avatar{width:30px;height:30px;}"]);

var UserProfile = _styledComponents["default"].div.withConfig({
  displayName: "LoginButton__UserProfile",
  componentId: "njq1cu-1"
})(["margin-top:5px;width:200px;height:260px;padding:24px;display:flex;flex-direction:column;justify-content:center;align-items:center;border-radius:4px;background-color:#ffffff;box-shadow:2px 2px 6px 0 rgba(0,0,0,0.1),-2px -2px 6px 0 rgba(0,0,0,0.1);z-index:99999;.user-avatar{width:64px;height:64px;}.user-label{font-size:10px;font-weight:500;letter-spacing:0.83px;color:#6e6e6e;text-transform:capitalize;margin-top:24px;}.user-name{font-size:20px;font-weight:900;text-align:center;color:#222222;margin:8px 0 24px;}.user-did{margin:0 0 16px;}.user-logout{}"]);

var _default = (0, _session.withDidSession)(LoginButton);

exports["default"] = _default;